export default "__VITE_ASSET__Dj9sode8__"